import SJButton from '@/components/SJButton'
import SJImageCell from '@/components/SJImageCell'
import SJSpace from '@/components/SJSpace'
import { getPlayers } from '@/services/player'
import { Player, PlayerListRes } from '@/services/types/player'
import user from '@/stores/user'
import useValidateCmcc from '@/hooks/useValidateCmcc'
import { PullToRefresh, Toast } from 'antd-mobile'
import { observer } from 'mobx-react'
import { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'

const PlayerList = () => {
  document.title = '棋手列表'
  useValidateCmcc()
  const navigate = useNavigate()

  const [players, setPlayers] = useState<Player[]>([])

  useEffect(() => {
    fetchPlayers()
  }, [])

  const fetchPlayers = async () => {
    try {
      const res = (await getPlayers()) as unknown as PlayerListRes
      console.log(res.list)
      setPlayers(res.list)
    } catch (error) {}
  }

  const goPlayerDetail = (player: Player) => {
    navigate(`/player/detail?playerId=${player.playerId}`)
  }

  const handleAddPlayer = () => {
    if (players.length >= 100) {
      Toast.show('群组内不能超过100个棋手')
    } else {
      navigate('/player/agreement', { state: { type: 'add' } })
    }
  }

  return (
    <div className="page player-list">
      <PullToRefresh onRefresh={fetchPlayers}>
        <div className="main">
          {players.map((item) => {
            return (
              <SJImageCell
                key={item.playerId}
                image={item.avatarUrl}
                name={item.name || '棋手'}
                role={user.userPlayer.playerId === item.playerId ? '管理员' : '棋手'}
                onClick={() => goPlayerDetail(item)}
              ></SJImageCell>
            )
          })}
        </div>
        <SJSpace height={100} />
        {/* <InfiniteScroll loadMore={loadMore} hasMore={hasMore}></InfiniteScroll> */}
      </PullToRefresh>
      <div className="btn-fixed">
        <SJButton type="primary" size="large" onClick={handleAddPlayer}>
          添加棋手
        </SJButton>
      </div>
    </div>
  )
}

export default observer(PlayerList)
